import React, { Fragment, useState } from 'react';

import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import { Typography, Modal, TextField, Card, Box, Button } from '@mui/material';

import { TextEditedContent } from 'components';
import { TopActions, Content, Title, Left } from './styles';
import logger from 'utils/logger';

const propTypes = {
  dataType: PropTypes.string,
  title: PropTypes.string,
  dataId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      orgId: PropTypes.number,
      userId: PropTypes.number,
      quotaUserId: PropTypes.number,
    }),
  ]),
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    userType: PropTypes.string,
    preferredLanguage: PropTypes.string,
    preferredTimezone: PropTypes.any,
  }),
  updateData: PropTypes.func,
};

const log = logger.createLogger('AdminDetailsModal');

const AdminDetails = ({ dataType, title, dataId, data, updateData }) => {
  const [dataJSON, setDataJSON] = useState(JSON.stringify(data, undefined, 4));
  const [isEditing, setEditing] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const onDataDetailsChange = (event) => {
    setDataJSON(event.target.value);
  };

  const OnConfirmModal = () => {
    updateData(dataId, dataJSON);
    setConfirmModalOpen(false);
    setEditing(false);
  };

  return (
    <Fragment>
      <TopActions>
        <Typography
          variant="h6"
          gutterBottom
          style={{
            fontWeight: 'bold',
            marginTop: '20px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}>
          {title ? title : `${dataType}: ${JSON.stringify(dataId)}`}
        </Typography>
      </TopActions>
      <Content>
        <Left>
          <Title>Data Details</Title>
          {isEditing ? (
            <Fragment>
              <TextField
                variant="outlined"
                multiline
                fullWidth
                defaultValue={dataJSON}
                onChange={onDataDetailsChange}
                sx={{
                  '& .MuiInputBase-root': {
                    height: '400px',
                    overflow: 'hidden',
                  },
                  '& textarea': {
                    height: 'calc(100% - 32px) !important',
                    overflow: 'auto !important',
                    resize: 'none',
                    padding: '16px',
                    boxSizing: 'border-box',
                  },
                }}
              />
              <Grid
                container
                paddingTop={3}
                spacing={3}
                justifyContent="space-between">
                <Grid>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      color: 'white',
                    }}
                    onClick={() => setConfirmModalOpen(true)}>
                    Update
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => setEditing(false)}>
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Fragment>
          ) : (
            <Fragment>
              <div
                style={{
                  maxHeight: '600px',
                  overflow: 'auto',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  padding: '12px',
                }}>
                <TextEditedContent
                  content={dataJSON}
                  onClick={() => setEditing(true)}
                />
              </div>
            </Fragment>
          )}
        </Left>
      </Content>
      {confirmModalOpen && (
        <Modal
          open={confirmModalOpen}
          onClose={() => setConfirmModalOpen(false)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Card
            sx={{ margin: 4, marginTop: 3, maxHeight: '800px', width: '80%' }}>
            <Box py={3} px={3} mt={3} mx={3}>
              <Typography mb={1}>Confirm</Typography>
              <Typography>
                You are going to update a {dataType} as below:
              </Typography>
              <div
                style={{
                  maxHeight: '400px',
                  overflow: 'auto',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  padding: '12px',
                  margin: '20px 0px',
                }}>
                <TextEditedContent content={dataJSON} />
              </div>
              <Grid spacing={3} container justifyContent="space-between">
                <Grid>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      color: 'white',
                      width: '50%',
                      marginLeft: '25%',
                    }}
                    onClick={OnConfirmModal}>
                    Confirm
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{
                      width: '50%',
                      marginLeft: '25%',
                    }}
                    onClick={() => {
                      setConfirmModalOpen(false);
                    }}>
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Modal>
      )}
    </Fragment>
  );
};

AdminDetails.propTypes = propTypes;

export default AdminDetails;
